import script from "./MultiChartsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiChartsPage.vue?vue&type=script&setup=true&lang=js"

import "./MultiChartsPage.vue?vue&type=style&index=0&id=6d712722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d712722"]])

export default __exports__